module.exports = __webpack_public_path__ + "static/media/onTimeTick.e23d5a44.svg";